import { createGlobalState } from 'services/createGlobalState';
import { OIDCClient } from 'infrastructure/oidc/OIDCClient';

export const {
    useWithState: useWithOIDCClient,
    useState: useOIDCClient,
    useDispatch: useSetOIDCClient,
} = createGlobalState<OIDCClient | null>((_, v) => v, null);
